import { createContext, useContext, type ReactNode } from "react";

export type TransportAppearance = "legacy" | "product-v2";

const TransportAppearanceContext = createContext<TransportAppearance | null>(null);

export const TransportAppearanceProvider = ({
    appearance,
    children,
}: {
    appearance: TransportAppearance;
    children: ReactNode;
}) => <TransportAppearanceContext.Provider value={appearance}>{children}</TransportAppearanceContext.Provider>;

export const useTransportAppearance = (fallback?: TransportAppearance): TransportAppearance => {
    const appearance = useContext(TransportAppearanceContext);

    if (appearance === null) {
        if (fallback !== undefined) return fallback;

        throw new Error("useTransportAppearance must be used within TransportAppearanceProvider");
    }

    return appearance;
};
